module.exports = __webpack_public_path__ + "6e96a6821df8c85be1dde8972e8dadbc.svg";